import { orchestrator } from 'satcheljs';
import { setCalendarGroupDisplayOrder } from '../actions/setCalendarGroupDisplayOrder';
import getCalendarGroupWithDisplayOrderRESTService from '../services/getCalendarGroupWithDisplayOrderRESTService';
import { getCalendarGroupByGroupId, updateCalendarGroup } from 'owa-calendar-cache';
import { trace } from 'owa-trace';

/**
 * The action worker which handles setting of the calendar group display order.
 */
export default orchestrator(setCalendarGroupDisplayOrder, async actionMessage => {
    const { userIdentity, calendarGroupId } = actionMessage;

    try {
        const calendarGroup = getCalendarGroupByGroupId(calendarGroupId, userIdentity);
        const serviceResponse = await getCalendarGroupWithDisplayOrderRESTService(
            userIdentity,
            calendarGroup.calendarGroupId.id
        );

        if (serviceResponse) {
            updateCalendarGroup(calendarGroupId, userIdentity, {
                DisplayOrder: serviceResponse.DisplayOrder,
            });
        } else {
            trace.warn('Unable to set calendar group display order.');
        }
    } catch (error) {
        trace.warn('Unable to set calendar group display order.');
        return;
    }
});
